import { createDiv, createDom, makeClickable, removeDom } from "../domUtils.mjs";
import createError from "./createError.mjs";
const open = function(imageData) {
  return new Promise(function(resolve, reject) {
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv("devkit-instant-mock-shareAsync", overlay);
    const box = createDiv("devkit-instant-mock-shareAsync-box", container);
    const image = createDom("div", "devkit-instant-mock-shareAsync-image", box);
    image.style.backgroundImage = "url(" + imageData + ")";
    const divButtons = createDiv("devkit-instant-mock-shareAsync-buttons", box);
    const cancel = createDiv(
      "devkit-instant-mock-shareAsync-button",
      divButtons
    );
    cancel.innerText = "Cancel";
    const share = createDiv(
      "devkit-instant-mock-shareAsync-button button-blue",
      divButtons
    );
    share.innerText = "Share";
    makeClickable(share, () => {
      removeDom(overlay);
      resolve();
    });
    makeClickable(cancel, () => {
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
  });
};
const openTournamentShare = function() {
  return new Promise(function(resolve, reject) {
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv(
      "devkit-instant-mock-shareAsyncTournament",
      overlay
    );
    const box = createDiv(
      "devkit-instant-mock-shareAsyncTournament-box",
      container
    );
    const divText = createDiv(
      "devkit-instant-mock-shareAsyncTournament-text",
      box
    );
    createDom("h1", null, divText).innerText = "Tournament";
    createDom("p", null, divText).innerText = "Do you want to share your score?";
    const divButtons = createDiv(
      "devkit-instant-mock-shareAsyncTournament-buttons",
      box
    );
    const cancel = createDiv(
      "devkit-instant-mock-shareAsyncTournament-button",
      divButtons
    );
    cancel.innerText = "Cancel";
    const share = createDiv(
      "devkit-instant-mock-shareAsyncTournament-button button-blue",
      divButtons
    );
    share.innerText = "Share";
    makeClickable(share, () => {
      removeDom(overlay);
      resolve();
    });
    makeClickable(cancel, () => {
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
  });
};
const shareAsyncDialog = { open, openTournamentShare };
export {
  shareAsyncDialog as default
};
